import { useTranslation } from 'react-i18next'
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import Save from '@mui/icons-material/Save'
import { Dialog } from '@carsys/ui'

export interface SubmitConfirmationProps {
  open: boolean
  onCancel: () => void
  onConfirm: () => void
}

export function SubmitConfirmation(props: SubmitConfirmationProps) {
  const { t } = useTranslation()

  return (
    <Dialog open={props.open}>
      <DialogTitle>{t('Form.SubmitConfirmation.Title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('Form.SubmitConfirmation.Content')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={props.onCancel}>
          {t('Form.SubmitConfirmation.Cancel')}
        </Button>
        <Button color='primary' onClick={props.onConfirm} startIcon={<Save />} variant='contained'>
          {t('Form.SubmitConfirmation.Confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
